/// <reference lib="dom" />
/** @jsx h */
import { type ComponentChildren, h } from "preact";
import { useState } from "preact/hooks";

export interface DatGraphProps {
  label: string;
  inline?: ComponentChildren;
  editor?: ComponentChildren;
  children?: ComponentChildren;
  defaultOpen?: boolean;
}

export function DatGraph(props: DatGraphProps) {
  const [open, setOpen] = useState(props.defaultOpen ?? false);
  return (
    <li class="cr graph" style={{ display: "block", padding: 0 }}>
      <div
        role="button"
        tabIndex={0}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 4,
          minHeight: 24,
          padding: "1px 2px 1px 8px",
          cursor: "pointer",
          userSelect: "none",
        }}
        onClick={() => setOpen(!open)}
        onKeyPress={() => setOpen(!open)}
      >
        <span
          class="label-text"
          style={{
            width: "40%",
            color: "white",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {open ? "▾" : "▸"} {props.label}
        </span>
        <span style={{ width: "60%", overflow: "hidden" }}>{props.inline}</span>
      </div>
      {open && props.editor && <div style={{ padding: "4px 0 4px 8px" }}>{props.editor}</div>}
      {open && props.children && <ul>{props.children}</ul>}
    </li>
  );
}
